import { useState } from 'react'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IApprovalComment, IField } from '@/types/tasksApprovals'
import { formatDate } from '@/utils/date'

const Comments = ({ item }: { item: IField }) => {
    const comments = item.value as IApprovalComment[]
    const dateColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')
    const [showPreview, setShowPreview] = useState(true)

    return (
        <AccordionRoot multiple variant="gigiOutline" py="8px" key={item.name}>
            <AccordionItem value={item.name}>
                <AccordionItemTrigger py="0" px="24px" onClick={() => setShowPreview(!showPreview)}>
                    <Box as="span" flex="1" textAlign="left">
                        <Text fontSize="12px" pb="4px">
                            {item.name}
                        </Text>
                        {showPreview && (
                            <>
                                <Text fontSize="14px" fontWeight="bold">
                                    {comments[0].comment.slice(0, 25)}...
                                </Text>
                            </>
                        )}
                    </Box>
                </AccordionItemTrigger>

                <AccordionItemContent mt="16px" p="24px">
                    <Box>
                        {comments.map((comment: IApprovalComment, idx) => {
                            const isNotLastItem = idx < comments.length - 1
                            return (
                                <Box key={item.name + idx}>
                                    <Box mb={isNotLastItem ? '16px' : ''}>
                                        <Text fontSize="14px" fontWeight="bold" mb="8px">
                                            {comment.author}
                                        </Text>
                                        <Text fontSize="12px" mb="8px">
                                            {comment.comment}
                                        </Text>
                                        <Text fontSize="12px" color={dateColor}>
                                            {formatDate(comment.date)}
                                        </Text>
                                    </Box>
                                    {isNotLastItem && <Box divideX="2px" mb="16px" />}
                                </Box>
                            )
                        })}
                    </Box>
                </AccordionItemContent>
            </AccordionItem>
        </AccordionRoot>
    )
}

export default Comments
